var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import cx from 'clsx';
import { labelStyles } from '../input_label/InputLabel.css';
import { labelStyles as inputLabelStyles } from '../input/Input.css';
import { radioGroupStyles } from './RadioGroup.css';
const RadioContext = React.createContext(null);
export const useRadioGroup = () => {
    const context = React.useContext(RadioContext);
    if (!context) {
        throw new Error('A `<Radio />` component can only be used inside a parent `<RadioGroup />`.');
    }
    return context;
};
const RadioGroupComponent = React.forwardRef(function RadioGroup(_a, ref) {
    var { as, children, className, errorId, hasError = false, isDisabled = false, name, onChange, selectedValue } = _a, rest = __rest(_a, ["as", "children", "className", "errorId", "hasError", "isDisabled", "name", "onChange", "selectedValue"]);
    const Component = as || `fieldset`;
    return (_jsx(RadioContext.Provider, { value: { hasError, isDisabled, name, onChange, selectedValue }, children: _jsx(Component, Object.assign({}, rest, { "aria-errormessage": errorId, "aria-invalid": hasError, className: cx(radioGroupStyles, className), ref: ref, role: "radiogroup", children: children })) }));
});
const RadioLegend = React.forwardRef(function RadioLegend(_a, ref) {
    var { children, className } = _a, rest = __rest(_a, ["children", "className"]);
    return (_jsx("legend", Object.assign({ className: cx(labelStyles, inputLabelStyles, className) }, rest, { ref: ref, children: children })));
});
export const RadioGroup = RadioGroupComponent;
RadioGroup.Legend = RadioLegend;
